import { useEffect } from "react";
import { Link } from "react-router-dom";

function PaymentSuccess() {
  useEffect(function () {
    window.scrollTo(0, 0);
  }, []);

  // Razorpay passes these as query params on redirect
  var params   = new URLSearchParams(window.location.search);
  var paymentId = params.get("razorpay_payment_id") || "";

  return (
    <div className={"ps-page"}>
      <div className={"ps-card"}>
        <div className={"ps-icon"}>✓</div>
        <h1>Payment Successful!</h1>
        <p className={"ps-sub"}>
          Thank you for booking the Basic Website Package. We've received your
          payment and will reach out within 24 hours to schedule your discovery
          call.
        </p>

        {paymentId && (
          <div className={"ps-ref"}>
            <span>Payment ID</span>
            <code>{paymentId}</code>
          </div>
        )}

        <div className={"ps-next"}>
          <p>What happens next:</p>
          <ol>
            <li>Check your email for a payment confirmation from Razorpay.</li>
            <li>Our team will contact you within 24 hours to schedule a 30-min discovery call.</li>
            <li>We'll share a content checklist so you're ready to go.</li>
          </ol>
        </div>

        <div className={"ps-actions"}>
          <a href={"mailto:contact@nuevoalture.com"} className={"btn-primary"}>
            Email Us
          </a>
          <Link to={"/"} className={"btn-ghost"}>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
